import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from '../components/Loader';
import { getAllCategories } from '../Api/categories';
import { Pagination, Stack } from '@mui/material';

function Categories() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const perPage = 30; // Number of categories per page

    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('user_data')) || {};
        if (userData.isSuperAdmin) {
            navigate('/dashboard');
        }
    }, [navigate]);

  function navigateCategoryPage(slug) {
  navigate(`/category/${slug}`);
}


    useEffect(() => {
        const fetchCategories = async () => {
            setLoading(true);
            try {
                const { data, totalPages } = await getAllCategories(currentPage, perPage);
                setCategories(Array.isArray(data) ? data : []);
                setTotalPages(totalPages);
            } catch (error) {
                console.error('Error fetching categories:', error);
                setCategories([]);
                setTotalPages(1);
            } finally {
                setLoading(false);
            }
        };

        fetchCategories();
    }, [currentPage]);

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <div className="content-wrapper">

                    <section className="category-page">
                        <div className="container">
                            <h3 style={{ fontSize: '22px', textAlign: 'center' }}>
                                {`Categories`.toUpperCase()}
                            </h3>
                            <div className="d-grid">
                                {categories && Array.isArray(categories) && categories.length > 0 ? (
                                    categories.map((item, index) =>
                                        item.name !== 'Uncategorized' ? (
                                            <div
                                                key={index}
                                                style={{
                                                    width: 'fit-content',
                                                    background: '#fff',
                                                    cursor: 'pointer',
                                                    margin: 'auto',
                                                }}
                                                onClick={() => navigateCategoryPage(item.slug)}
                                            >
                                                {item.image && item.image.src ? (
                                                    <img
                                                        src={item.image.src}
                                                        alt={item.name}
                                                        style={{ height: '110px', width: '110px' }}
                                                    />
                                                ) : (
                                                    <div
                                                        style={{
                                                            height: '110px',
                                                            width: '110px',
                                                            background: '#f0f0f0',
                                                        }}
                                                    >
                                                        No Image
                                                    </div>
                                                )}
                                                <h5 style={{ textAlign: 'center' }}>{item.name}</h5>
                                            </div>
                                        ) : null
                                    )
                                ) : (
                                    <div>No categories available</div>
                                )}
                            </div>
                            <Stack spacing={2} style={{ margin: '5% auto 0', display: 'flex', alignItems: 'center' }}>
                                <Pagination
                                    count={totalPages}
                                    page={currentPage}
                                    onChange={handlePageChange}
                                    color="primary"
                                />
                            </Stack>
                        </div>
                    </section>
                </div>
            )}
        </>
    );
}

export default Categories;